module.exports = __webpack_public_path__ + "img/arrow-up.d91d9437.svg";